import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { noteApi } from '../../../api/noteApi.js';
import { NavBar } from '../../app/navBar.js';
import moment from 'moment';
import './noteSelect.css';

function NoteSelect() {
    const [notes, setNotes] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                const response = await noteApi.getNoteList();
                setNotes(response.data.rows);
            } catch (err) {
                setError(err.message || "An error occurred.");
            }
        })();
    }, []);

    const getButtonColor = (to) => {
        switch (to) {
            case 'WEYLIN':
                return 'blue';
            case 'RORY':
                return 'pink';
            case 'BOTH':
                return 'green';
            default:
                return 'defaultColor'; // Define a default color in your CSS
        }
    };

    return (
        <div>
            <NavBar/>
            <h2>Please select a note</h2>

            {error ? (
                <p>{error}</p>
            ) : (
                <div className="notes-container">
                    <ul>
                        {Array.isArray(notes) && notes.map(note => (
                            <li key={note.id}>
                                <button
                                    className={`albumButton ${getButtonColor(note.to)}`}
                                    onClick={() => navigate(`/view-note/${note.id}`)}
                                >
                                    📝 {note.title} : {moment(note.writtenOn.date).format('MM/DD/YYYY')}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export { NoteSelect };
